import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { Button, Card, Container } from "react-bootstrap";
import { Link } from "react-router-dom";

import { useAPIStore } from "../../Store/APIStore";
// Store
import { pathTitles, useStore } from "../../Store/Store";
// Components
import { BorderAll, Carousel, ChevronLeft, ChevronRight } from "../Common";
// Enhanced Profile Components
import { EnhancedPuppyProfile } from "./PuppyProfile/EnhancedPuppyProfile";

export const PuppyProfile = (props) => {
  const { puppy } = props;
  const getLink = useStore((state) => state.getLink);
  const { puppies, fetchPuppies } = useAPIStore();

  // Feature flag for enhanced profile (can be controlled via environment variable or config)
  const useEnhancedProfile = process.env.REACT_APP_ENHANCED_PROFILE !== "false";

  // Fetch puppies on component mount to ensure we have complete navigation data
  useEffect(() => {
    fetchPuppies(); // Always fetch to ensure we have the latest complete list
  }, [fetchPuppies]);

  // If enhanced profile is enabled, use the new component
  if (useEnhancedProfile) {
    return <EnhancedPuppyProfile puppy={puppy} />;
  }

  // Calculate navigation based on current puppy position in API data
  // Only calculate when puppies array is populated
  const currentIndex =
    puppies.length > 0
      ? puppies.findIndex((p) => p.profilePath === puppy.profilePath)
      : -1;

  const showLeft = currentIndex > 0 ? "show" : "";
  const showRight =
    currentIndex >= 0 && currentIndex + 1 < puppies.length ? "show" : "";

  const pathLeft =
    showLeft && puppies[currentIndex - 1]
      ? `${getLink(pathTitles.VIEWPUPPIES)}${puppies[currentIndex - 1].profilePath}`
      : "";
  const pathRight =
    showRight && puppies[currentIndex + 1]
      ? `${getLink(pathTitles.VIEWPUPPIES)}${puppies[currentIndex + 1].profilePath}`
      : "";
  return (
    <>
      <Container className="puppy_profile_container small_container clear">
        <Card.Title className="title">{puppy.cardHeaderTitle}</Card.Title>
        <div className="icons">
          <Button
            className={`transparent chevron-left ${showLeft}`}
            as={Link}
            to={pathLeft}
          >
            {showLeft && <ChevronLeft className={`chevron-left ${showLeft}`} />}
          </Button>

          <Button
            className="transparent"
            as={Link}
            to={getLink(pathTitles.VIEWPUPPIES)}
          >
            <BorderAll className="border-all" />
          </Button>

          <Button
            className={`transparent chevron-right ${showRight}`}
            as={Link}
            to={pathRight}
          >
            <ChevronRight className={`chevron-right ${showRight}`} />
          </Button>
        </div>
        <div className="profile_container">
          <span className={`profile ${puppy.image}`} />
          <Card.Title className="title">
            {puppy.cardHeaderTitle} - Trained {puppy.breed} for Sale
          </Card.Title>
          {puppy.available ? (
            <>
              <Card.Subtitle className="title available_date">
                <Card.Subtitle className="title available">
                  AVAILABLE : &nbsp;
                </Card.Subtitle>
                <Card.Subtitle className="title available_date">
                  {puppy.availableDate}
                </Card.Subtitle>
              </Card.Subtitle>
            </>
          ) : (
            <Card.Subtitle className="title not_available">
              {puppy.availableDate}
            </Card.Subtitle>
          )}
          <Card.Body className="statistics">
            <ul>
              {puppy.breedLong ? (
                <li>Breed : {puppy.breedLong}</li>
              ) : (
                <li>Breed: {puppy.breed}</li>
              )}
              {puppy.breeder && <li>Breeder : {puppy.breeder}</li>}
              {puppy.projectedSize && (
                <li>Adult Size : {puppy.projectedSize}</li>
              )}
              {puppy.dob && <li>Date of Birth : {puppy.dob}</li>}
              {puppy.sex && <li>Sex : {puppy.sex}</li>}
            </ul>
          </Card.Body>
          <Card.Body className="body">{puppy.personality}</Card.Body>
          {puppy.saleUpdate && (
            <Card.Body className="body sold">{puppy.saleUpdate}</Card.Body>
          )}
          {/* Use optimized carousel if available, fallback to legacy format */}
          {puppy.carouselOptimized && puppy.carouselOptimized.length > 0 ? (
            <Carousel optimizedImages={puppy.carouselOptimized} size="large" />
          ) : puppy.carousel ? (
            <Carousel images={puppy.carousel} />
          ) : null}
          <Card.Body className="program_message">
            {puppy.cardHeaderTitle} has been raised and trained through our{" "}
            <Link to={getLink(pathTitles.YOURPUPPYSTRAINING)}>
              Buy a Trained Puppy Program.
            </Link>{" "}
          </Card.Body>
          <Card.Body className="delivery_message">
            Every Buy a Trained Puppy is delivered to your city with all
            necessary supplies, a certificate of health and liftime support.
            Several days of one-on-one private training for you and{" "}
            {puppy.cardHeaderTitle} in your home as you begin your life together
            are included.
          </Card.Body>
          <Card.Body className="price">
            <div className="message">
              Cost for {puppy.cardHeaderTitle} to be your trained puppy:
            </div>
            <div className={`${puppy.available ? "available" : "sold"}`}>
              {!puppy.available && "SOLD! Original"} Price: {puppy.price}
            </div>
          </Card.Body>
          <Card.Body className="out_of_state_message">
            Live in another state? Ask us about puppy delivery options.
          </Card.Body>
          <Card.Body className="out_of_state_message">
            *Additional fees may apply.
          </Card.Body>
        </div>
      </Container>
    </>
  );
};

PuppyProfile.propTypes = {
  puppy: PropTypes.object,
};
